import { Route, Routes } from "react-router-dom";
import AccountLedgerCreateScreen from "screens/App/CRM/Payment/AccountLedger/AccountLedgerCreateScreen";
import AccountLedgerDetailScreen from "screens/App/CRM/Payment/AccountLedger/AccountLedgerDetailScreen";
import AccountLedgerEditScreen from "screens/App/CRM/Payment/AccountLedger/AccountLedgerEditScreen";
import AccountLedgerListScreen from "screens/App/CRM/Payment/AccountLedger/AccountLedgerListScreen";

import NotFoundScreen from "screens/NotFoundScreen";

const AccountLedgerRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<AccountLedgerListScreen />} />
      <Route path="create" element={<AccountLedgerCreateScreen />} />
      <Route path=":id/detail" element={<AccountLedgerDetailScreen />} />
      <Route path=":id/edit" element={<AccountLedgerEditScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default AccountLedgerRouter;
